import { Maybe } from '../../global/types';

/**
 * Escapes string to be safely inserted into HTML as innerHTML
 */
export const escape = (str: Maybe<string>): Maybe<string> => {
  if (typeof str !== 'string') {
    return str;
  }
  return str.replace(/[&<>"'/]/g, (match) => {
    switch (match) {
      case '&':
        return '&amp;';
      case '<':
        return '&lt;';
      case '>':
        return '&gt;';
      case '"':
        return '&quot;';
      case "'":
        return '&#x27;';
      case '/':
        return '&#x2F;';
    }
    return match;
  });
};
